import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-car-insurance-footer',
  imports: [TranslatePipe],
  templateUrl: './car-insurance-footer.component.html',
  styleUrl: './car-insurance-footer.component.scss'
})
export class CarInsuranceFooterComponent {
  lang!: string;
  constructor(private route: ActivatedRoute, private router: Router) { }
  ngOnInit() {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    const possibleLang = pathSegments[0];
    const supportedLangs = ['en', 'vi'];
    this.lang = supportedLangs.includes(possibleLang) ? possibleLang : 'en';
  }
  onPrivacy() {
    if (this.lang === 'en') {
      window.open('https://www.livwell.vn/privacy-policy', '_blank');
    } else {
      window.open('https://www.livwell.vn/vi/privacy-policy', '_blank');
    }
  }

  onTerms() {
    if (this.lang === 'en') {
      window.open('https://www.livwell.vn/terms-conditions', '_blank');
    } else {
      window.open('https://www.livwell.vn/vi/terms-conditions', '_blank');
    }
  }
}
